import { useEffect,useState } from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import { post } from '../../utils/axios'
import Phone from '@mui/icons-material/Phone'

const Support = () => {

    const [content,setContent] = useState([])

    useEffect(() => {
        const postedData = {
            key: 'support'
        }
        post('Config/GetConfigByKey',postedData).then(({ data }) => {
            if(data.isSuccess){
                const contactData = data.data.value.split('\n')
                const contentData = []
                contactData.map(item => {
                    if(item)
                        contentData.push(item)
                })
                setContent(contentData)
            }
        })
    },[])

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">اطلاعات پشتیبانی</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%',mb: 5 }} className="business-item contact-detail-parent">
                    <CardContent style={{ paddingBottom: 16 }}>
                        {content.map((contact,index) => {
                            let phone = contact.toString().split(':')[1].replace(')','').replace('(','').replace('-','').replace('+','').trim()
                            let purePhone = contact.toString().split(':')[1].replace(')','').replace('(','').replace('+','').trim()
                            let areaCode = purePhone.split('-')[1]
                            let phoneNumber = purePhone.split('-')[0]
                            return <p key={index} className="others-page-content" style={{ position: 'relative' }}>
                            {contact}
                            {/^-?\d+$/.test(phone) ? <a className="phone-icon-action" href={`tel:${areaCode + phoneNumber}`}><Phone /></a> : ''}
                        </p>
                        })}
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default Support